import {
  Component,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DeviceHelperService } from '@tvd/cdk/browser';
import { AuthService, HasAccessPipe } from '@tvd/data-access/auth';
import { ThemeService } from '@tvd/data-access/theme';
import { BottomBarComponent } from '@tvd/ui/bottom-bar/bottom-bar';
import { CookieConsentBanner } from '@tvd/ui/cookie-consent-banner';
import { TrialBannerComponent } from '@tvd/ui/trial-banner/trial-banner';
import { RootContainer } from './root-container';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CookieConsentBanner,
    TrialBannerComponent,
    HasAccessPipe,
    RootContainer,
    BottomBarComponent,
  ],
  templateUrl: './app.html',
  host: {
    class: 'block h-full relative',
  },
})
export class App {
  readonly #auth = inject(AuthService);
  /** has to be injected in root to init */
  readonly theme = inject(ThemeService);

  readonly loggedIn = this.#auth.loggedIn;

  readonly isSM = inject(DeviceHelperService).isSM;

  readonly backdrop = signal(false);

  readonly bottomBarRef =
    viewChild.required<BottomBarComponent>(BottomBarComponent);

  closePanel() {
    this.bottomBarRef().closeAction();
  }
}
